import { useMotionValue, useScroll, useVelocity, useSpring, useTransform, wrap, useAnimationFrame, motion } from "framer-motion";
import { useRef } from "react";
import './ParallaxText.scss';

export type ParallaxTextProps = { children: JSX.Element, reversed?: boolean };
const ParallaxText = ({ children, reversed = false }: ParallaxTextProps): JSX.Element => {
    const baseX = useMotionValue(0);
    const { scrollY } = useScroll();
    const scrollVelocity = useVelocity(scrollY);
    const smoothVelocity = useSpring(scrollVelocity, {
        damping: 30,
        stiffness: 200
    });
    const maxV = reversed ? -10 : 10;
    const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, maxV], {
        clamp: false
    });

    const x = useTransform(baseX, (v) => `${wrap(-20, -32.5, v)}%`); // ??????????
    const directionFactor = useRef<number>(1);

    useAnimationFrame((t, delta) => {
        if (velocityFactor.get() < 0) {
            directionFactor.current = -1;
        } else if (velocityFactor.get() > 0) {
            directionFactor.current = 1;
        }

        let moveBy = directionFactor.current * (delta / 1000) * 1;

        moveBy += moveBy * velocityFactor.get() * directionFactor.current;

        baseX.set(baseX.get() + moveBy);
    });

    return (
        <motion.div className="parallax-div" style={{ x }}>
            <span>{children}</span>
            <span>{children}</span>
            <span>{children}</span>
            <span>{children}</span>
            <span>{children}</span>
            <span>{children}</span>
            <span>{children}</span>
            <span>{children}</span>
        </motion.div>
    );
}

export default ParallaxText;
